// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"573d8e6a","531":"5b8a3d7c","726":"3f3bafb2","727":"d987348f","967":"733b35a2"}[chunkId] + ".chunk.js";
};